class Hero extends HTMLElement {
    constructor() {
        super();
        this.prevButton = null;
        this.nextButton = null;
        this.slides = null;
        this.currentIndex = 0;
        this.maxIndex = 0;
        this.autoPlayInterval = null;
    }

    connectedCallback() {
        this.prevButton = this.querySelector('.prev');
        this.nextButton = this.querySelector('.next');
        this.slides = this.querySelectorAll('.slide');
        this.maxIndex = this.slides.length - 1;

        this.prevButton?.addEventListener('click', this.handlePrevClick.bind(this));
        this.nextButton?.addEventListener('click', this.handleNextClick.bind(this));

        // Auto-advance every 10 seconds
        this.startAutoPlay();
    }

    startAutoPlay() {
        this.autoPlayInterval = setInterval(() => {
            this.nextButton?.click();
        }, 10000);
    }

    resetAutoPlay() {
        clearInterval(this.autoPlayInterval);
        this.startAutoPlay();
    }

    goToSlide(index) {
        this.slides.forEach(slide => slide.classList.remove('active'));
        this.slides[index].classList.add('active');
        this.currentIndex = index;
    }

    handlePrevClick(event) {
        event.preventDefault();
        const newIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.goToSlide(newIndex);
        this.resetAutoPlay();
    }

    handleNextClick(event) {
        event.preventDefault();
        const newIndex = (this.currentIndex + 1) % this.slides.length;
        this.goToSlide(newIndex);
        this.resetAutoPlay();
    }

    disconnectedCallback() {
        this.prevButton?.removeEventListener('click', this.handlePrevClick);
        this.nextButton?.removeEventListener('click', this.handleNextClick);
        clearInterval(this.autoPlayInterval);
    }
}


customElements.define('hero-component', Hero);
